import { SxProps } from '@mui/material';

export const styles: { [key: string]: SxProps } = {
  container: {
    position: 'relative'
  },
  tooltip: {
    position: 'absolute',
    zIndex: 1000,
    p: 2,
    borderRadius: 2,
    boxShadow: 3,
    left: 20,
    top: 20,
    minWidth: 250,
    bgcolor: 'background.paper'
  },
  tooltipContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    mb: 1
  },
  tooltipText: {
    flex: 1
  },
  closeButton: {
    ml: 1,
    mt: -1,
    mr: -1
  },
  deleteButton: {
    position: 'absolute',
    top: -20,
    right: -20,
    backgroundColor: 'white',
    '&:hover': { backgroundColor: '#f5f5f5' }
  },
  insertButton: {
    position: 'absolute',
    top: -16,
    right: -16,
    backgroundColor: 'white',
    '&:hover': { backgroundColor: '#f5f5f5' }
  }
}; 